import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, ENVIRONMENT } from "../config";
import * as actionTypes from "../store/actions";

import Title from "./Common/Title";
import Home from "./Home/Home";
import About from "./Content/About";
import Contact from "./Content/Contact";
import Header from "./Common/Header";
import Footer from "./Common/Footer";
import Products from "./Products/Products";
import Product from "./Products/Product";
import ProtectedRoute from "./MyAccount/ProtectedRoute";
import MyAccount from "./MyAccount/MyAccount";
import Orders from "./MyAccount/Orders";
import Addresses from "./MyAccount/Addresses";
import Address from "./MyAccount/Address";
import Profile from "./MyAccount/Profile";
import ChangePassword from "./MyAccount/ChangePassword";
import Track from "./MyAccount/Track";
import Dashboard from "./MyAccount/Dashboard";
import NotFound from "./Content/NotFound";
import Search from "./Products/Search";
import Faqs from "./Content/Faqs";
import PrivacyPolicy from "./Content/PrivacyPolicy";
import Shipping from "./Content/Shipping";
import TermsConditions from "./Content/TermsConditions";
import Cart from "./ShoppingCart/Cart";
import Guest from "./ShoppingCart/Guest";
import Checkout from "./ShoppingCart/Checkout";
import Success from "./ShoppingCart/Success";
import Failed from "./ShoppingCart/Failed";
import { Loading } from "./Common/Loading";
import store from "../store/store";
import secureStorage from "../helpers/locStore";
import useIdleLogout from "../helpers/useIdleLogout";

const Root = ({
  setSettings,
  setTranslations,
  setCategories,
  setCurrencies,
  setCurrency,
}) => {
  useIdleLogout(30);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const respApp = await axios(`${BASE_URL}/settings`);
      setSettings(respApp.data.settings);
      setTranslations(respApp.data.translations);
      setCategories(respApp.data.categories);
      setCurrencies(respApp.data.currencies);
      const currencyData =
        secureStorage.getItem("currency") === undefined ||
        secureStorage.getItem("currency") === null ||
        secureStorage.getItem("currency") === ""
          ? respApp.data.currencies[0]
          : secureStorage.getItem("currency");
      setCurrency(currencyData);
      setLoading(false);
    };
    fetchData()
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        if (ENVIRONMENT === "development") {
          console.log(err);
        }
      });
  }, [loading]);
  console.log(store.getState());
  return loading === true ? (
    <Loading></Loading>
  ) : (
    <>
      <Title />
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/products/:id" element={<Products />}></Route>
        <Route path="/product/:id" element={<Product />}></Route>
        <Route path="/search/:id" element={<Search />}></Route>
        <Route path="/cart" element={<Cart />}></Route>
        <Route path="/guest" element={<Guest />}></Route>
        <Route path="/checkout" element={<Checkout />}></Route>
        <Route path="/success" element={<Success />}></Route>
        <Route path="/failed" element={<Failed />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/faqs" element={<Faqs />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
        <Route path="/shipping-exchange" element={<Shipping />}></Route>
        <Route path="/terms-conditions" element={<TermsConditions />}></Route>
        <Route path="/user" element={<MyAccount />}>
          <Route
            path="dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="addresses"
            element={
              <ProtectedRoute>
                <Addresses />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="addresses/new"
            element={
              <ProtectedRoute>
                <Address />
              </ProtectedRoute>
            }
          />
          <Route
            path="addresses/:id/edit"
            element={
              <ProtectedRoute>
                <Address />
              </ProtectedRoute>
            }
          />
          <Route
            path="orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          ></Route>
          <Route path="track" element={<Track />}></Route>
          <Route
            path="change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          ></Route>
        </Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <Footer />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSettings: (settings) =>
      dispatch({
        type: actionTypes.SET_SETTINGS,
        payload: settings,
      }),
    setTranslations: (translations) =>
      dispatch({
        type: actionTypes.SET_TRANSLATIONS,
        payload: translations,
      }),
    setCategories: (categories) =>
      dispatch({
        type: actionTypes.SET_CATEGORIES,
        payload: categories,
      }),
    setCurrencies: (currencies) =>
      dispatch({
        type: actionTypes.SET_CURRENCIES,
        payload: currencies,
      }),
    setCurrency: (currency) =>
      dispatch({
        type: actionTypes.SET_CURRENCY,
        payload: currency,
      }),
    setLanguage: (lang) =>
      dispatch({
        type: actionTypes.SET_LANGUAGE,
        payload: lang,
      }),
    setUser: (lang) =>
      dispatch({
        type: actionTypes.SET_LANGUAGE,
        payload: lang,
      }),
  };
};
export default connect(null, mapDispatchToProps)(Root);
